import React, { useState, useEffect } from 'react';
import './PatientProfileModal.css';
import * as Yup from 'yup';
import Form from '../../form/components/Form/Form';
import FormField from '../../form/components/FormField/FormField';
import Button from '../../form/components/Button/Button';
import ErrorMessage from '../../form/components/ErrorMessage/ErrorMessage';
import { ImCancelCircle } from 'react-icons/im';
import { FaCloudUploadAlt, FaTrashAlt } from  'react-icons/fa';
import { useRef } from 'react';
import { toast } from 'react-toastify';
import BeatLoader from "react-spinners/BeatLoader";
import ProgressBar from '../../Progress/Progress';
import moment from 'moment';
import { auth } from '../../../firebase/firebase-config';
import { doc, collection,query, where, getDocs, addDoc, setDoc, updateDoc, serverTimestamp   } from "firebase/firestore"; 
import { getStorage,  ref, uploadBytesResumable, getDownloadURL, deleteObject} from 'firebase/storage';

import { firebaseApp,  } from '../../../utils/firebaseConfig';
import { useAuthState } from 'react-firebase-hooks/auth';
import { db } from "../../../firebase/firebase-config";
import SelectFormField from '../../form/components/FormField/SelectFormField';


import {
    getAuth,
    updateProfile,
    createUserWithEmailAndPassword,
  } from "firebase/auth";

import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';

const initialValues= {
    name: null,
    phone: null,
    code: null,
    gender: 'none'
}

const override = {
    marginTop: '20px'
  };

const genderData = [
    {label: 'Select',  value: 'none'},
    {label: 'Male',  value: 'Male'},
    {label: 'Female',  value: 'Female'}
]

function PatientProfileModal({ onClose, onContentAdded } : any) {
    const [error, setError] = useState<any>(null);
    const [loading, setLoading] = useState(false);
    const currentDate = moment();
    const [user] = useAuthState(auth);

    // REPORT PDF
    const [reportPdfUrl, setReportPdfUrl] = useState<any>('');
    const [reportsPdfProgress,  setReportPdfProgress] = useState(0);
    const [isUploadingReportPdf, setIsUploadingReportPdf] = useState(false);

    // END OF ASSIGNEMTN
    const storage = getStorage(firebaseApp);
    

    // good
    const solutionFileRef: any = useRef(null);

    const validationSchema = Yup.object().shape({
        phone: Yup.string().min(9, 'Must be at least  9 digits').max(9, 'Must be 9 digits').required('Phone is required'),
        code: Yup.number().required('Code is Requireed'),
        name: Yup.string().required('Name is required'),
    })

    const handleSubmitData = async (values: any) => {

            // console.log('VALS:  ',  values);

            if(values?.length < 4 || values?.length > 4) {
                toast.error("Code Must Be 4 Digits", {
                    pauseOnHover: false,
                    closeOnClick: true,
                })

                return;
            }

            setLoading(true);

            const reqData = {
                phoneNumber: `+237${values.phone}`,
                gender: values.gender == 'none' ? null : values.gender,
                // email: `+237${values.phone}@medarc.org`,
                displayName: values.name,
                createdAt: serverTimestamp(),
                is_verified: true,
                device_token: null
            }

            const q = query(collection(db, "Patients"), where("phoneNumber", "==", reqData.phoneNumber));

            const querySnapshot = await getDocs(q);
            
            if(querySnapshot.size == 1) {
                setLoading(false);
                toast.error("Patient Already Exist", {
                    pauseOnHover: false,
                    closeOnClick: true,
                })
            }

           try {

            // CREATE ACCOUNT WITH EMAIL  AND PASSWORD
            let p_Code =  `${values?.code}101`;


    createUserWithEmailAndPassword(auth, `+237${values.phone}@medarc.org`, p_Code)
    .then((userCredential) => {
      const user = userCredential.user;

      if (userCredential) {
        updateProfile(user, {
          displayName: reqData.displayName,
        })
          .then(() => {
            // console.log(user.displayName);
          })
          .catch((error: any) => {
            console.log(error);
          });

        try {
          const docRef = setDoc(doc(db, "Patients", userCredential.user.uid), reqData);

        } catch (e) {
          console.error("Error adding document: ", e);
        }
      }
      toast.success("Patient Created", {
        pauseOnHover: false,
        closeOnClick: true,
      });
      setLoading(false);
      onContentAdded();
      onClose();
    })
    .catch((error: any) => {
      console.log(error)
      setLoading(false);
      toast.error("ERROR", {
        pauseOnHover: false,
        closeOnClick: true,
      });
    });
   


        //    const docRef = collection(db,"Patients")
            
        //    await addDoc(docRef, reqData);

            // setLoading(false);
            // onClose();
            // onContentAdded();
            // toast.success('Patient Created', {
            //     pauseOnHover: false,
            //     closeOnClick: true,
            // })

           } catch (error) {
            console.log('DATA: ', error);
            setLoading(false);
            toast.error("ERROR", {
                pauseOnHover: false,
                closeOnClick: true,
            })
           }
    }



    
    return (
        <div>
            <div  className='modal-container student-modal-assignment' id="reports-modal">
                <div className='modal-head'>
                    <p className="modal-title">Patient Data</p>
                    <ImCancelCircle style={{cursor: 'pointer'}} onClick={onClose} size={22} color="#fff"/>
                </div>
                <div className='modal-content'>
                <div style={{textAlign: 'center', marginBottom: '10px'}}>
                    <BeatLoader
                        color="#3080ED" 
                        loading={loading}
                        cssOverride={override}
                    />
                </div>
                <form action="" className="auth-form">

                {error && <ErrorMessage error={error} visible={true} />}
                <Form 
                    initialValues={initialValues}
                    onSubmit={handleSubmitData}
                    validationSchema={validationSchema}
                >
    

                        <p className="label-text">Patient's Name: </p>
                        <FormField  name="name" type="text" placeholder="Enter Patient's Name"/>

                        <p className="label-text">Patient's Phone: </p>
                        <FormField  name="phone" type="number" placeholder="Enter Patient's Phone"/>

                        <p className="label-text">4 Digit Code: </p>
                        <FormField  name="code" type="number" placeholder="Enter Patient's Code"/>
               
                        <p className="label-text">Patient's Gender: </p>
                        <SelectFormField name="gender" options={genderData} placeholder="Select Gender" />

                      {!loading && <Button isOutLined={true} isFullWidth={false} title="SUBMIT DATA"/>}

                        </Form>
                </form>
                </div>
            </div>
            <div className="modal-shadow" onClick={onClose}>
               
            </div>
        </div>
    );
}

export default PatientProfileModal;

